import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";

import { Configuration } from "./config-model"; 
import { environment } from "src/environments/environment";

export function ConfigLoader(configService:ConfigService){
  return () => configService.load(environment.configFile)
}

@Injectable()
export class ConfigService {

  private config:Configuration;
  public configSubject: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {}

  load(url: string) {
    console.log("ConfigService Load");
    return this.http.get(url)
    .toPromise()
    .then((config:any) => {
      this.config = config;
      console.log(this.config);
      console.log(this.config.backendUrlBase);
      console.log(this.config.backendUrlBaseOcc);
      this.configSubject.next(this.config);
    })
    .catch((err:any) => {
      console.error('Error config.services.ts')
    })
  }

  getConfiguration(): Configuration {
    console.log("ConfigService geConfiguration");
    return this.config;
  }

}
